import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from '../components/common/ErrorFallback';
import store from '../store';
import { setMainCommands } from './util';
import './CommonToAllApps';
import ThemeProvider from './ThemeProvider';
import { ApiaUtil } from '@apia/components';
import { Collector } from '@apia/validations';

export interface IExternalApp {
  children?: React.ReactNode;
}

setMainCommands();
const apiaUtil = ApiaUtil.instance;
window.ApiaUtil = Object.assign({}, ApiaUtil.instance, {
  collector: Collector,
});
Object.assign(window.ApiaUtil, { instance: window.ApiaUtil });

const ExternalApp = ({ children }: IExternalApp) => {
  return (
    <ThemeProvider>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <apiaUtil.Component />
        <Provider store={store}>{children}</Provider>
      </ErrorBoundary>
    </ThemeProvider>
  );
};

export default ExternalApp;
